export default __webpack_public_path__ + "static/media/piano small.40dd4a7d.svg";